import _slicedToArray from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import EventEmitter from 'eventemitter3';
import { PublicKey } from '@solana/web3.js';
import bs58 from 'bs58';

var Wallet = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Wallet, _EventEmitter);

  var _super = _createSuper(Wallet);

  function Wallet(provider, _network) {
    var _this;

    _classCallCheck(this, Wallet);

    _this = _super.call(this);
    _this._network = _network;
    _this._publicKey = null;
    _this._popup = null;
    _this._handlerAdded = false;
    _this._nextRequestId = 1;
    _this._autoApprove = false;
    _this._responsePromises = new Map();

    _this.handleMessage = function (e) {
      var _a;

      if (_this._injectedProvider && e.source === window || e.origin === ((_a = _this._providerUrl) === null || _a === void 0 ? void 0 : _a.origin) && e.source === _this._popup) {
        if (e.data.method === 'connected') {
          var newPublicKey = new PublicKey(e.data.params.publicKey);

          if (!_this._publicKey || !_this._publicKey.equals(newPublicKey)) {
            if (_this._publicKey && !_this._publicKey.equals(newPublicKey)) {
              _this.handleDisconnect();
            }

            _this._publicKey = newPublicKey;
            _this._autoApprove = !!e.data.params.autoApprove;

            _this.emit('connect', _this._publicKey);
          }
        } else if (e.data.method === 'disconnected') {
          _this.handleDisconnect();
        } else if (e.data.result || e.data.error) {
          var promises = _this._responsePromises.get(e.data.id);

          if (promises) {
            var _promises = _slicedToArray(promises, 2),
                resolve = _promises[0],
                reject = _promises[1];

            if (e.data.result) {
              resolve(e.data.result);
            } else {
              reject(new Error(e.data.error));
            }
          }
        }
      }
    };

    _this._beforeUnload = function () {
      void _this.disconnect();
    };

    if (isInjectedProvider(provider)) {
      _this._injectedProvider = provider;
    } else if (isString(provider)) {
      _this._providerUrl = new URL(provider);
      _this._providerUrl.hash = new URLSearchParams({
        origin: window.location.origin,
        network: _this._network
      }).toString();
    } else {
      throw new Error('provider parameter must be an injected provider or a URL string.');
    }

    return _this;
  }

  _createClass(Wallet, [{
    key: "handleConnect",
    value: function handleConnect() {
      var _this2 = this;

      var _a;

      if (!this._handlerAdded) {
        this._handlerAdded = true;
        window.addEventListener('message', this.handleMessage);
        window.addEventListener('beforeunload', this._beforeUnload);
      }

      if (this._injectedProvider) {
        return new Promise(function (resolve) {
          void _this2.sendRequest('connect', {});
          resolve();
        });
      } else {
        window.name = 'parent';
        this._popup = window.open((_a = this._providerUrl) === null || _a === void 0 ? void 0 : _a.toString(), '_blank', 'location,resizable,width=460,height=675');
        return new Promise(function (resolve) {
          _this2.once('connect', resolve);
        });
      }
    }
  }, {
    key: "handleDisconnect",
    value: function handleDisconnect() {
      var _this3 = this;

      if (this._handlerAdded) {
        this._handlerAdded = false;
        window.removeEventListener('message', this.handleMessage);
        window.removeEventListener('beforeunload', this._beforeUnload);
      }

      if (this._publicKey) {
        this._publicKey = null;
        this.emit('disconnect');
      }

      this._responsePromises.forEach(function (_ref, id) {
        var _ref2 = _slicedToArray(_ref, 2),
            reject = _ref2[1];

        _this3._responsePromises.delete(id);

        reject(new Error('Wallet disconnected'));
      });
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(method, params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this4 = this;

        var requestId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(method !== 'connect' && !this.connected)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Wallet not connected');

              case 2:
                requestId = this._nextRequestId;
                ++this._nextRequestId;
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  var _a, _b, _c, _d;

                  _this4._responsePromises.set(requestId, [resolve, reject]);

                  if (_this4._injectedProvider) {
                    _this4._injectedProvider.postMessage({
                      jsonrpc: '2.0',
                      id: requestId,
                      method: method,
                      params: Object.assign({
                        network: _this4._network
                      }, params)
                    });
                  } else {
                    (_a = _this4._popup) === null || _a === void 0 ? void 0 : _a.postMessage({
                      jsonrpc: '2.0',
                      id: requestId,
                      method: method,
                      params: params
                    }, (_c = (_b = _this4._providerUrl) === null || _b === void 0 ? void 0 : _b.origin) !== null && _c !== void 0 ? _c : '');

                    if (!_this4.autoApprove) {
                      (_d = _this4._popup) === null || _d === void 0 ? void 0 : _d.focus();
                    }
                  }
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "publicKey",
    get: function get() {
      return this._publicKey;
    }
  }, {
    key: "connected",
    get: function get() {
      return this._publicKey !== null;
    }
  }, {
    key: "autoApprove",
    get: function get() {
      return this._autoApprove;
    }
  }, {
    key: "connect",
    value: function connect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this._popup) {
                  this._popup.close();
                }

                _context2.next = 3;
                return this.handleConnect();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this._injectedProvider) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.sendRequest('disconnect', {});

              case 3:
                if (this._popup) {
                  this._popup.close();
                }

                this.handleDisconnect();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "sign",
    value: function sign(data, display) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var response, signature, publicKey;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (data instanceof Uint8Array) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('Data must be an instance of Uint8Array');

              case 2:
                _context4.next = 4;
                return this.sendRequest('sign', {
                  data: data,
                  display: display
                });

              case 4:
                response = _context4.sent;
                signature = bs58.decode(response.signature);
                publicKey = new PublicKey(response.publicKey);
                return _context4.abrupt("return", {
                  signature: signature,
                  publicKey: publicKey
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(transaction) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var response, signature, publicKey;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.sendRequest('signTransaction', {
                  message: bs58.encode(transaction.serializeMessage())
                });

              case 2:
                response = _context5.sent;
                signature = bs58.decode(response.signature);
                publicKey = new PublicKey(response.publicKey);
                transaction.addSignature(publicKey, signature);
                return _context5.abrupt("return", transaction);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "signAllTransactions",
    value: function signAllTransactions(transactions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var response, signatures, publicKey;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.sendRequest('signAllTransactions', {
                  messages: transactions.map(function (tx) {
                    return bs58.encode(tx.serializeMessage());
                  })
                });

              case 2:
                response = _context6.sent;
                signatures = response.signatures.map(function (s) {
                  return bs58.decode(s);
                });
                publicKey = new PublicKey(response.publicKey);
                transactions = transactions.map(function (tx, idx) {
                  tx.addSignature(publicKey, signatures[idx]);
                  return tx;
                });
                return _context6.abrupt("return", transactions);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "diffieHellman",
    value: function diffieHellman(publicKey) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (publicKey instanceof Uint8Array) {
                  _context7.next = 2;
                  break;
                }

                throw new Error('Data must be an instance of Uint8Array');

              case 2:
                _context7.next = 4;
                return this.sendRequest('diffieHellman', {
                  publicKey: publicKey
                });

              case 4:
                response = _context7.sent;
                return _context7.abrupt("return", response);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }]);

  return Wallet;
}(EventEmitter);

export { Wallet as default };

function isString(a) {
  return typeof a === 'string';
}

function isInjectedProvider(a) {
  return isObject(a) && 'postMessage' in a && typeof a.postMessage === 'function';
}

function isObject(a) {
  return typeof a === 'object' && a !== null;
}